import api from "@/services/api/Api.js";

export default {
	list(params) {
		return api().get(`/login-types`, {
			params: params,
		});
	},
};
